module.exports = __webpack_public_path__ + "static/img/10.99ae4bd9.png";